import { Pipe, PipeTransform } from '@angular/core';
import { COMMON_EMAIL_DOMAINS } from '../constants/common-domains';

@Pipe({
  name: 'emailFilter',
  standalone: false
})
export class EmailFilterPipe implements PipeTransform {
  transform(_: unknown, query: string): string[] {
    if (!query) return [];

    // Si el usuario ya escribió un @, sugiere solo los dominios que coincidan
    const [name, domainPart] = query.split('@');
    if (domainPart !== undefined) {
      return COMMON_EMAIL_DOMAINS
        .filter(domain => domain.startsWith(domainPart))
        .map(domain => `${name}@${domain}`);
    }

    // Si no hay @, sugiere todas las combinaciones posibles
    return COMMON_EMAIL_DOMAINS.map(domain => `${query}@${domain}`);
  }
}